import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../api';
import "./Header.css";

const Header = () => {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    checkAuthStatus();
  }, []);

  const checkAuthStatus = async () => {
    try {
      const token = localStorage.getItem('token');
      if (token) {
        const response = await authAPI.getProfile();
        setUser(response.data);
        setIsAuthenticated(true);
      } else {
        setUser(null);
        setIsAuthenticated(false);
      }
    } catch (error) {
      localStorage.removeItem('token');
      setUser(null);
      setIsAuthenticated(false);
    }
  };

  const navigateToDashboard = (role) => {
    if (role === 'admin') {
      navigate('/admin');
    } else if (role === 'dropshipper') {
      navigate('/dropshipper');
    } else {
      navigate('/dashboard');
    }
  };

  return (
    <header className="newhome-nav">
      <div className="newhome-brand" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
        <img src="/images/newhome/logo.png" alt="CHdropshipping logo" />
      </div>
      <nav className="newhome-nav-links">
        <a onClick={() => navigate('/products')} style={{ cursor: 'pointer' }}>CH Products</a>
        <a onClick={() => navigate('/dropshipper/my-stores')} style={{ cursor: 'pointer' }}>Integration</a>
        <a onClick={() => navigate('/about-us')} style={{ cursor: 'pointer' }}>About us</a>
      </nav>
      <div className="newhome-actions">
        {isAuthenticated && user ? (
          <div
            className="newhome-user"
            onClick={() => navigateToDashboard(user.role)}
            role="button"
            tabIndex={0}
            onKeyDown={(event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                navigateToDashboard(user.role);
              }
            }}
          >
            <span>{user.username}</span>
            <div className="newhome-user-avatar">
              <img src="/images/newhome/avatar-user-icon.svg" alt="User avatar" />
            </div>
          </div>
        ) : (
          <>
            <button 
              className="newhome-button"
              onClick={() => navigate('/register')}
            >
              Register
            </button>
            <button
              className="newhome-button newhome-button--ghost"
              onClick={() => navigate('/login')}
            >
              Login
            </button>
          </>
        )}
      </div>
    </header>
  );
};

export default Header;
